/* Escapure Tresor – Halloween 2026 */
(function () {
  var HANDOFF_KEY = 'escapureTresorHandoff';
  var HANDOFF_TTL = 60000;
  var PIN_ROUNDS = 1000;
  var TRIES_KEY = 'escapureTresorTries';
  var FREE_TRIES = 5;
  var LOCK_BASE = 30000;
  var LOCK_MAX = 15 * 60000;

  function normPath(p) {
    p = (p || '/').replace(/\/+$/, '');
    return p || '/';
  }

  function sameOriginUrl(raw) {
    if (!raw) return null;
    raw = String(raw).trim();
    if (!/^https?:\/\//i.test(raw) && /^[\w.-]+\.[\w.-]+/.test(raw)) raw = 'https://' + raw;
    raw = raw.replace(/^(https?:\/\/[^/?#]+)(\?)/i, '$1/$2');
    try {
      var url = new URL(raw, location.origin);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
      return new URL(url.pathname + url.search + url.hash, location.origin);
    } catch (e) {
      return null;
    }
  }

  function init(root) {
    if (root.dataset.trInit) return;
    root.dataset.trInit = '1';
    var $ = function (s) { return root.querySelector(s); };
    var stage = $('[data-tr-stage]');
    var openAt = Date.parse(root.dataset.openAt);
    var forced = root.dataset.forcePhase;
    var soldOut = root.dataset.soldOut === 'true';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var form = $('[data-tr-signup]');
    var dialog = $('[data-tr-dialog]');
    var emailStep = form && form.querySelector('[data-tr-email-step]');
    var pinStep = form && form.querySelector('[data-tr-pin-step]');
    var emailInput = form && form.querySelector('input[type=email]');
    var pinInput = form && form.querySelector('input[name=pin]');
    var errEl = form && form.querySelector('[data-tr-error]');
    var submitBtn = form && form.querySelector('[data-tr-submit]');
    var switchBtn = form && form.querySelector('[data-tr-switch]');
    var fineEl = form && form.querySelector('[data-tr-fine]');
    var okEl = form && form.querySelector('[data-tr-ok]');
    var dialogEmail = dialog && dialog.querySelector('[data-tr-dialog-email]');
    var dialogContinue = dialog && dialog.querySelector('[data-tr-dialog-continue]');
    var step = 'email';
    var emailDone = false;
    var busy = false;
    var checking = false;
    var timers = [];

    var qp = new URLSearchParams(location.search).get('tresor');
    if (qp && /^(teaser|open|sold)$/.test(qp)) forced = qp;

    function later(fn, ms) {
      timers.push(setTimeout(fn, ms));
    }

    function phaseNow() {
      if (forced && forced !== 'auto') return forced;
      if (soldOut) return 'sold';
      return (isNaN(openAt) || Date.now() >= openAt) ? 'open' : 'teaser';
    }

    function setPhase(p, force) {
      if (root.dataset.phase === p && !force) return;
      root.dataset.phase = p;
      if (stage && !busy) {
        var sold = p === 'sold';
        if (sold) stage.classList.remove('tr-safe--checking', 'tr-safe--wrong');
        stage.classList.toggle('tr-safe--unlatched', sold);
        stage.classList.toggle('tr-safe--opened', sold);
      }
      syncFormForPhase();
    }

    function pinAvailable() {
      return root.dataset.phase === 'open';
    }

    function clearError() {
      if (errEl) errEl.textContent = '';
      if (emailInput) emailInput.removeAttribute('aria-invalid');
      if (pinInput) pinInput.removeAttribute('aria-invalid');
    }

    function showError(msg, input) {
      if (errEl) errEl.textContent = msg;
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus({ preventScroll: true });
      }
    }

    function showStep(next, focus) {
      if (busy) return;
      if (next === 'pin' && !pinAvailable()) return;
      step = next;
      var isPin = next === 'pin';
      if (emailStep) emailStep.hidden = isPin;
      if (pinStep) pinStep.hidden = !isPin;
      if (emailInput) emailInput.disabled = isPin;
      if (pinInput) {
        pinInput.disabled = !isPin;
        if (!isPin) pinInput.value = '';
      }
      if (okEl) okEl.hidden = true;
      if (submitBtn) {
        submitBtn.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = isPin
          ? (root.dataset.labelPin || 'Tresor öffnen')
          : (root.dataset.labelSignup || 'PIN sichern');
      }
      if (switchBtn) {
        switchBtn.hidden = !pinAvailable();
        switchBtn.disabled = false;
        switchBtn.textContent = isPin
          ? (root.dataset.labelSwitchEmail || 'Zurück zur E-Mail')
          : (root.dataset.labelSwitchPin || 'Ich habe bereits einen PIN');
      }
      if (fineEl) fineEl.hidden = isPin;
      clearError();
      if (focus !== false) {
        var target = isPin ? pinInput : emailInput;
        if (target) target.focus({ preventScroll: true });
      }
    }

    function showTeaserSuccess() {
      step = 'done';
      if (emailStep) emailStep.hidden = true;
      if (pinStep) pinStep.hidden = true;
      if (submitBtn) submitBtn.hidden = true;
      if (switchBtn) switchBtn.hidden = true;
      if (fineEl) fineEl.hidden = true;
      if (okEl) okEl.hidden = false;
    }

    function syncFormForPhase() {
      if (!form || busy || root.dataset.phase === 'sold') return;
      if (pinAvailable() && (step === 'done' || (emailDone && step === 'email' && okEl && !okEl.hidden))) {
        showStep('pin', false);
        return;
      }
      if (switchBtn && step !== 'done') switchBtn.hidden = !pinAvailable();
    }

    function continueFromDialog() {
      if (dialog && dialog.open) dialog.close();
      if (pinAvailable()) showStep('pin');
      else showTeaserSuccess();
    }

    var cd = $('[data-tr-countdown]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      setPhase(phaseNow());
      if (!cd || isNaN(openAt)) return;
      var s = Math.floor(Math.max(0, openAt - Date.now()) / 1000);
      cd.querySelector('[data-d]').textContent = pad(Math.floor(s / 86400));
      cd.querySelector('[data-h]').textContent = pad(Math.floor(s % 86400 / 3600));
      cd.querySelector('[data-m]').textContent = pad(Math.floor(s % 3600 / 60));
      cd.querySelector('[data-s]').textContent = pad(s % 60);
    }
    setPhase(phaseNow(), true);
    tick();
    setInterval(tick, 1000);

    if (switchBtn) {
      switchBtn.addEventListener('click', function () {
        showStep(step === 'email' ? 'pin' : 'email');
      });
    }

    if (dialogContinue) {
      dialogContinue.addEventListener('click', continueFromDialog);
    }
    if (dialog) {
      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        continueFromDialog();
      });
    }

    function submitEmail() {
      var v = emailInput.value.trim();
      emailInput.value = v;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        showError(root.dataset.msgInvalid || 'Bitte gib eine gültige E-Mail-Adresse ein.', emailInput);
        return;
      }
      clearError();
      submitBtn.disabled = true;
      var params = new URLSearchParams(location.search);
      var props = { tresor_phase: root.dataset.phase, tresor_signup_page: location.pathname };
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        if (params.get(k)) props[k] = params.get(k);
      });
      var source = root.dataset.source || 'Tresor Halloween 2026';
      if (params.get('utm_source')) source += ' · ' + params.get('utm_source');
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: v, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: root.dataset.listId } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok && r.status !== 202) throw new Error(r.status);
        emailDone = true;
        if (dialogEmail) dialogEmail.textContent = v;
        if (dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
          if (dialogContinue) dialogContinue.focus();
        } else {
          continueFromDialog();
        }
        try { if (window.fbq) window.fbq('track', 'Lead', { content_name: 'Tresor Halloween 2026' }); } catch (x) {}
        try {
          document.dispatchEvent(new CustomEvent('tresor:signup', { detail: { phase: root.dataset.phase } }));
        } catch (x) {}
      }).catch(function () {
        showError(root.dataset.msgError || 'Das hat nicht geklappt. Bitte versuch es gleich noch einmal.', emailInput);
      }).then(function () { submitBtn.disabled = false; });
    }

    function cssPx(n) {
      n = Number(n);
      return (isFinite(n) ? n : 0).toFixed(2);
    }

    function cssScale(n) {
      n = Number(n);
      if (!isFinite(n)) return '4';
      return Math.min(8, Math.max(1.5, n)).toFixed(3);
    }

    function holeGeo() {
      var hole = stage && (stage.querySelector('.tr-safe__inside') || stage.querySelector('.tr-safe__door-wrap') || stage);
      if (!hole) return null;
      var rect = hole.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var r = Math.max(rect.width / 2, 1);
      var vv = window.visualViewport;
      var vx = vv ? vv.offsetLeft : 0;
      var vy = vv ? vv.offsetTop : 0;
      var W = vv ? vv.width : document.documentElement.clientWidth;
      var H = vv ? vv.height : window.innerHeight;
      var d = Math.max(
        Math.hypot(cx - vx, cy - vy),
        Math.hypot(vx + W - cx, cy - vy),
        Math.hypot(cx - vx, vy + H - cy),
        Math.hypot(vx + W - cx, vy + H - cy)
      );
      var body = document.body.getBoundingClientRect();
      return { x: cx - body.left, y: cy - body.top, scale: (d / r) * 1.08 };
    }

    /* Always center the safe. The zoom scale is measured from this spot. Vertical only. */
    function scrollSafeIntoView(behavior) {
      var current = window.scrollY || window.pageYOffset || 0;
      if (!stage) return current;
      var rect = stage.getBoundingClientRect();
      var vv = window.visualViewport;
      var viewH = vv ? vv.height : (window.innerHeight || document.documentElement.clientHeight);
      var offset = vv ? vv.offsetTop : 0;
      var y = current + rect.top - offset - (viewH - rect.height) / 2;
      var max = Math.max(0, document.documentElement.scrollHeight - viewH);
      if (y < 0) y = 0;
      if (y > max) y = max;
      if (Math.abs(current - y) < 2) return current;
      try {
        window.scrollTo({ top: y, left: 0, behavior: behavior || 'auto' });
      } catch (e) {
        window.scrollTo(0, y);
      }
      return y;
    }

    /* Fixed body keeps the scroll offset. overflow:hidden on the root jumps the page on iOS. */
    function lockPage(y) {
      var body = document.body;
      if (body.dataset.trScrollY != null) return;
      if (typeof y !== 'number' || !isFinite(y)) y = window.scrollY || window.pageYOffset || 0;
      body.dataset.trScrollY = String(y);
      body.style.position = 'fixed';
      body.style.top = (-y) + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    }

    function unlockPage() {
      var body = document.body;
      if (body.dataset.trScrollY == null) return;
      var y = parseFloat(body.dataset.trScrollY) || 0;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      delete body.dataset.trScrollY;
      window.scrollTo(0, y);
    }

    /* Literal scale in keyframes: WebKit and Chrome drop interpolation of scale(var()). */
    function writeZoomKeyframes(geo) {
      var style = document.getElementById('tr-vault-zoom-style');
      if (!style) {
        style = document.createElement('style');
        style.id = 'tr-vault-zoom-style';
        document.head.appendChild(style);
      }
      style.textContent = '@keyframes tr-vault-zoom{from{transform:translate3d(0,0,0) scale(1)}to{transform:translate3d(0,0,0) scale(' + cssScale(geo.scale) + ')}}';
    }

    function clearZoom() {
      var html = document.documentElement;
      html.classList.remove('tr-tresor-zooming', 'tr-tresor-entering');
      ['--tr-zoom-x', '--tr-zoom-y', '--tr-zoom-scale'].forEach(function (name) {
        html.style.removeProperty(name);
      });
      var style = document.getElementById('tr-vault-zoom-style');
      if (style) style.remove();
      unlockPage();
    }

    function storeHandoff(url) {
      try {
        sessionStorage.setItem(HANDOFF_KEY, JSON.stringify({
          v: 1,
          exp: Date.now() + HANDOFF_TTL,
          path: normPath(url.pathname)
        }));
      } catch (e) {}
    }

    function revealInline() {
      if (form) form.hidden = true;
      var rv = $('[data-tr-reveal]');
      if (rv) {
        rv.hidden = false;
        rv.focus({ preventScroll: true });
      }
    }

    function zoomAndRedirect(url) {
      var html = document.documentElement;
      /* 980ms lets the .95s door swing finish, then the 1.5s CSS zoom. */
      later(function () {
        /* Smooth scroll already ran. Snap to the same center so the zoom origin matches. */
        var scrollY = scrollSafeIntoView('auto');
        lockPage(scrollY);
        void document.body.offsetWidth;
        var geo = holeGeo();
        if (geo) {
          html.style.setProperty('--tr-zoom-x', cssPx(geo.x) + 'px');
          html.style.setProperty('--tr-zoom-y', cssPx(geo.y) + 'px');
          html.style.setProperty('--tr-zoom-scale', cssScale(geo.scale));
          if (!reducedMotion) writeZoomKeyframes(geo);
        }
        void html.offsetWidth;
        html.classList.add('tr-tresor-zooming');
        storeHandoff(url);
      }, reducedMotion ? 40 : 980);
      later(function () {
        storeHandoff(url);
        location.assign(url.href);
      }, reducedMotion ? 280 : 2560);
    }

    function openVault() {
      busy = true;
      step = 'opening';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Tresor wird geöffnet …';
      }
      if (pinInput) pinInput.disabled = true;
      if (switchBtn) switchBtn.disabled = true;
      if (stage) {
        stage.classList.remove('tr-safe--wrong');
        stage.classList.add('tr-safe--checking');
      }
      scrollSafeIntoView(reducedMotion ? 'auto' : 'smooth');
      later(function () {
        if (stage) stage.classList.add('tr-safe--unlatched');
      }, reducedMotion ? 0 : 400);
      later(function () {
        if (stage) stage.classList.add('tr-safe--opened');
        try { if (window.fbq) window.fbq('trackCustom', 'TresorOpened'); } catch (x) {}
        var reward = sameOriginUrl(root.dataset.rewardUrl);
        var designMode = window.Shopify && window.Shopify.designMode;
        if (reward && !designMode) {
          zoomAndRedirect(reward);
        } else {
          busy = false;
          revealInline();
        }
      }, reducedMotion ? 50 : 640);
    }

    function readTries() {
      try {
        var t = JSON.parse(localStorage.getItem(TRIES_KEY) || 'null');
        if (t && typeof t.n === 'number' && typeof t.until === 'number') return t;
      } catch (e) {}
      return { n: 0, until: 0 };
    }

    function writeTries(t) {
      try { localStorage.setItem(TRIES_KEY, JSON.stringify(t)); } catch (e) {}
    }

    function lockedSeconds() {
      return Math.max(0, Math.ceil((readTries().until - Date.now()) / 1000));
    }

    function showLocked(sec) {
      var msg = root.dataset.msgLocked || 'Zu viele Versuche. Bitte warte [seconds] Sekunden.';
      showError(msg.replace('[seconds]', sec), pinInput);
    }

    function registerWrongPin() {
      var t = readTries();
      t.n += 1;
      if (t.n >= FREE_TRIES) {
        t.until = Date.now() + Math.min(LOCK_BASE * Math.pow(2, t.n - FREE_TRIES), LOCK_MAX);
      }
      writeTries(t);
      return lockedSeconds();
    }

    function submitPin() {
      if (!pinAvailable() || checking) return;
      var locked = lockedSeconds();
      if (locked) { showLocked(locked); return; }
      var val = pinInput.value.trim().toUpperCase();
      if (!val) {
        showError(root.dataset.msgPin || 'Der PIN passt nicht.', pinInput);
        return;
      }
      if (stage) stage.classList.remove('tr-safe--wrong');
      checking = true;
      submitBtn.disabled = true;
      pinDigest(val, root.dataset.pinSalt || '').then(function (hash) {
        checking = false;
        submitBtn.disabled = false;
        if (!hash || hash !== root.dataset.pinHash) {
          if (stage) { void stage.offsetWidth; stage.classList.add('tr-safe--wrong'); }
          var sec = registerWrongPin();
          if (sec) showLocked(sec);
          else showError(root.dataset.msgPin || 'Der PIN passt nicht.', pinInput);
          return;
        }
        writeTries({ n: 0, until: 0 });
        clearError();
        openVault();
      }).catch(function () {
        checking = false;
        submitBtn.disabled = false;
        showError(root.dataset.msgError || 'Das hat nicht geklappt. Bitte versuch es gleich noch einmal.', pinInput);
      });
    }

    /* Back navigation may restore this page from bfcache mid-zoom */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || step !== 'opening') return;
      clearZoom();
      try { sessionStorage.removeItem(HANDOFF_KEY); } catch (x) {}
      busy = false;
      revealInline();
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy || (dialog && dialog.open)) return;
        if (step === 'email') submitEmail();
        else if (step === 'pin') submitPin();
      });
    }

    showStep('email', false);
  }

  function sha256(str) {
    if (!(window.crypto && crypto.subtle)) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
    });
  }

  /* Must mirror the Liquid hash in sections/tresor-halloween.liquid: sha256(salt + ':' + PIN), then PIN_ROUNDS more passes */
  function pinDigest(pin, salt) {
    var chain = sha256(salt + ':' + pin);
    for (var i = 0; i < PIN_ROUNDS; i++) chain = chain.then(sha256);
    return chain;
  }

  function boot() { document.querySelectorAll('[data-tresor]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();